import React, { useState } from "react";
import Tilt from "react-parallax-tilt";
import { QRCodeSVG } from "qrcode.react";
import logo from './Eeshan-Logo.webp'
const DigitalPlatinumCard = () => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className="card-container pt-5">
      <Tilt glareEnable={true} glareMaxOpacity={0.25} scale={1.05} tiltMaxAngleX={10} tiltMaxAngleY={10}>
        <div className={`platinum-card ${flipped ? "flipped" : ""}`}>
          {/* Front Side */}
          <div className="card-face card-front p-4">
            <h5 className="brand-title text-center mb-4 d-flex align-items-center">
  <div className="logo-circle d-flex align-items-center justify-content-center me-3 bg-white">
        <img src={logo} width='60' height='auto' alt="" />  
        </div>        
         ईशान IVF
            </h5>

            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
               
                  
                
                <div>
                  <h6 className="card-name mb-1"> डॉ संजय केदार शर्मा (MBBS MS), <br/> डॉ जया शर्मा (MBBS DGO MRCOG ( LONDON ))  </h6>
                  <p className="card-role mb-1">Director , Owner </p>
                  <p className="card-phone mb-0">+91 9812178133 , +91 9992113933</p>
                </div>
              </div>
              <div className="qr-code-front">
                <QRCodeSVG
                  value={`BEGIN:VCARD
VERSION:3.0
N: डॉ संजय केदार शर्मा  डॉ जया शर्मा 
TEL:+919812178133
TEL:+919992113933
EMAIL:kedar.sanjay@gmail.com
END:VCARD`}
                  size={80}
                  fgColor="#000000"
                />
               
              </div>
            </div>

            {/* <p className="address mt-4 small text-muted">
              <i className="fa fa-map-marker me-2"></i>
              Office No-306, 3rd Floor, RG Trade Tower, <br />
              Netaji Subhash Place, New Delhi - 110034
            </p> */}
          </div>

          {/* Back Side */}
          <div className="card-face card-back p-4">
            <h5 className="brand-title text-center mb-4 d-flex align-items-center">
  <div className="logo-circle d-flex align-items-center justify-content-center me-3 bg-white">
        <img src={logo} width='60' height='auto' alt="" />  
        </div>        
         ईशान IVF
            </h5>


            <p className="address mt-3 small text-muted">
              <div> <i className="fa fa-map-marker me-2"></i>281 R Model Town, Near Maharana Pratap chowk, Model Town Rewari, Haryana , Pincode-123401</div>
            </p>
            <div className="qr-box ">
              <QRCodeSVG
                value="https://maps.app.goo.gl/bKcbzaREAAqtgHcn7"
                size={60}
                fgColor="#000000"
              />
            </div>
          </div>
        </div>
      </Tilt>

      {/* Manual flip button */}
      <button
        className="platinum-btn mt-4 rounded-pill"
        onClick={() => setFlipped(!flipped)}
      >
        {flipped ? "Show Front" : "Show Back"}
      </button>

      {/* Action buttons */}
      <div className="d-flex flex-column gap-3 mt-5 w-75 mx-auto" style={{ maxWidth: "280px" }}>
        <a href="/eshan-ivf.vcf" download className="platinum-btn">Add To Contacts</a>
        <a href="tel:+919812178133" className="platinum-btn">Call Now</a>
        <a href="mailto:kedar.sanjay@gmail.com" className="platinum-btn">Email Us</a>
        <a href="mailto:jayasharma06110@gmail.com" className="platinum-btn">Email Us</a>

        <a href="https://wa.me/919812178133" target="_blank" className="platinum-btn">
  WhatsApp
</a>

        <a href="https://eeshanivf.com/" target="_blank" rel="noopener noreferrer" className="platinum-btn">Website</a>
        <a href="https://maps.app.goo.gl/bKcbzaREAAqtgHcn7" target="_blank" rel="noopener noreferrer" className="platinum-btn">Visit Location</a>
        {/* <a href="/brochure.pdf" download className="platinum-btn">Brochure</a> */}
      </div>
    </div>
  );
};

export default DigitalPlatinumCard;
